import { render } from "./login-main.vue?vue&type=template&id=58abaea2"
import script from "./login-main.vue?vue&type=script&lang=js"
export * from "./login-main.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__